import {useEffect,useRef,useState} from 'react';
import {Download,RefreshCw} from 'lucide-react';
import {registerFitnessServiceWorker} from './push-notifications.js';

type InstallChoice={outcome:'accepted'|'dismissed'};
type InstallPromptEvent=Event&{prompt:()=>Promise<void>;userChoice:Promise<InstallChoice>};

function isStandalone(){
  const navigatorWithStandalone=navigator as Navigator&{standalone?:boolean};
  return window.matchMedia('(display-mode: standalone)').matches||navigatorWithStandalone.standalone===true;
}

function isIos(){
  return /iPad|iPhone|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
}

export function PwaControls(){
  const [installPrompt,setInstallPrompt]=useState<InstallPromptEvent|null>(null),[installed,setInstalled]=useState(isStandalone),[showIosHelp,setShowIosHelp]=useState(false),[waitingWorker,setWaitingWorker]=useState<ServiceWorker|null>(null);
  const updateRequested=useRef(false);
  useEffect(()=>{
    const beforeInstall=(event:Event)=>{event.preventDefault();setInstallPrompt(event as InstallPromptEvent);};
    const appInstalled=()=>{setInstalled(true);setInstallPrompt(null);setShowIosHelp(false);};
    const controllerChanged=()=>{if(updateRequested.current)window.location.reload();};
    window.addEventListener('beforeinstallprompt',beforeInstall);
    window.addEventListener('appinstalled',appInstalled);
    navigator.serviceWorker?.addEventListener('controllerchange',controllerChanged);
    let registration:ServiceWorkerRegistration|null=null;
    const inspectWaiting=()=>{if(registration?.waiting&&navigator.serviceWorker.controller)setWaitingWorker(registration.waiting);};
    void registerFitnessServiceWorker().then(value=>{
      registration=value;
      if(!registration)return;
      inspectWaiting();
      const watchInstalling=()=>registration?.installing?.addEventListener('statechange',inspectWaiting);
      watchInstalling();
      registration.addEventListener('updatefound',watchInstalling);
    });
    return()=>{
      window.removeEventListener('beforeinstallprompt',beforeInstall);
      window.removeEventListener('appinstalled',appInstalled);
      navigator.serviceWorker?.removeEventListener('controllerchange',controllerChanged);
    };
  },[]);
  const install=async()=>{
    if(installPrompt){await installPrompt.prompt();await installPrompt.userChoice;setInstallPrompt(null);return;}
    setShowIosHelp(value=>!value);
  };
  const update=()=>{if(!waitingWorker)return;updateRequested.current=true;waitingWorker.postMessage({type:'SKIP_WAITING'});};
  const iosInstallAvailable=isIos()&&!installed;
  if(!waitingWorker&&!installPrompt&&!iosInstallAvailable)return null;
  const updating=Boolean(waitingWorker),title=updating?'Je dostupná nová verze':'Měj REŽIM po ruce',description=updating?'Aktualizace zabere jen pár sekund.':showIosHelp?'V Safari klepni na Sdílet a potom na Přidat na plochu.':'Nainstaluj si aplikaci na plochu a spusť ji i bez signálu.';
  return <aside className="pwa-control" aria-live="polite">
    <span className="pwa-control-icon" aria-hidden="true">{updating?<RefreshCw/>:<Download/>}</span>
    <span><strong>{title}</strong><small>{description}</small></span>
    <button type="button" onClick={()=>updating?update():void install()}>{updating?'Aktualizovat':showIosHelp?'Skrýt návod':'Nainstalovat'}</button>
  </aside>;
}
